import {
  APP_SETTING_LOAD_PHI_AUDIT_BEGIN,
  APP_SETTING_LOAD_PHI_AUDIT_SUCCESS,
  APP_SETTING_LOAD_PHI_AUDIT_FAILURE,
  APP_SETTING_LOAD_PHI_AUDIT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function loadProjectPHIAudit(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_PHI_AUDIT_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/phi-audit/project`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_LOAD_PHI_AUDIT_SUCCESS,
              data: res.data,
            });
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_LOAD_PHI_AUDIT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_PHI_AUDIT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectPHIAuditError() {
  return {
    type: APP_SETTING_LOAD_PHI_AUDIT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_PHI_AUDIT_BEGIN:
      return {
        ...state,
        loadProjectPHIAuditPending: true,
        loadProjectPHIAuditError: null,
      };

    case APP_SETTING_LOAD_PHI_AUDIT_SUCCESS:
      return {
        ...state,
        loadProjectPHIAuditPending: false,
        loadProjectPHIAuditError: null,
        projectPHIAudit: action.data.data,
        projectDetail: action.data.projectDetail,
      };

    case APP_SETTING_LOAD_PHI_AUDIT_FAILURE:
      return {
        ...state,
        loadProjectPHIAuditPending: false,
        loadProjectPHIAuditError: action.data.error,
      };

    case APP_SETTING_LOAD_PHI_AUDIT_DISMISS_ERROR:
      return {
        ...state,
        loadProjectPHIAuditError: null,
      };

    default:
      return state;
  }
}
